// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"673":"2f91d458","767":"af33865d"}[chunkId] + ".chunk.js";
};